import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const VisionPage = lazy(() => import('../pages/vision/page'));
const ProjectPage = lazy(() => import('../pages/project/page'));
const TechnologyPage = lazy(() => import('../pages/technology/page'));
const CommunityPage = lazy(() => import('../pages/community/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const SustainabilityPage = lazy(() => import('../pages/sustainability/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/vision',
    element: <VisionPage />
  },
  {
    path: '/project',
    element: <ProjectPage />
  },
  {
    path: '/technology',
    element: <TechnologyPage />
  },
  {
    path: '/community',
    element: <CommunityPage />
  },
  {
    path: '/会社概要',
    element: <AboutPage />
  },
  {
    path: '/sustainability',
    element: <SustainabilityPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;